import axios from "../utils/helpers/common/axios.config";
import useStore from "./useStore";
import { errorToaster } from "../utils/helpers/common/alert-service";
import { errorMessages } from "../utils/helpers/enums/messages.enum";

const useHttp = () => {
  const { logout, setLoading } = useStore();

  const isPreventLoaderAPI = (apiUrl: string): boolean => {
    const stopLoaderAPIs = [
      /^\/event\/\d+\/messages$/,
      /^\/event\/\d+\/chat$/,
      /^\/event\/cancellation-tickets\/\d+\/chat$/,
      /^\/admin-events\/\d+\/messages$/,
      /^\/admin-events\/\d+$/,
      
    ];
    return stopLoaderAPIs.some((regex) => regex.test(apiUrl.split("?")[0]));
  };

  function configureHeaders() {
    axios.interceptors.request.use(
      (config) => {
        if (!isPreventLoaderAPI(config.url)) setLoading(true);
        return config;
      },
      (error) => {
        // Promise.reject(error)
      }
    );
  }

  const configureInterceptors = () => {
    axios.interceptors.response.use(
      (response: any) => {
        setLoading(false);
        if (response?.data?.status === false || response?.data?.status == 0)
          displayApiErrors(response);
        return response;
      },
      async (error) => {
        setLoading(false);
        if (error?.response?.status === 401) {
          // Don't logout user for device-tokens/store failures (user might not be verified yet)
          const isDeviceTokenStore = error.config?.url?.includes("/device-tokens/store");
          if (!isDeviceTokenStore) {
            logout();
          }
          // Silently fail for device token store - user can retry after verification
        }
        return Promise.reject(error);
      }
    );
  };

  const displayApiErrors = (response: any) => {
    errorToaster(
      response?.data?.errors?.length &&
        typeof response?.data?.errors === "object"
        ? response?.data?.errors[0]
        : response?.data?.message?.length
        ? response?.data?.message
        : response?.data?.error?.length
        ? response?.data?.error
        : errorMessages.somethingWentWrong
    );
  };

  return {
    configureHeaders,
    configureInterceptors,
  };
};

export default useHttp;
